import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import CreditCurrencyLogo from '../../../../assets/target/images/CreditCurrencyLogo.svg';
import AppConfig from '../../../../config';
import { t } from '../../../../lang';
import { appSlice } from '../../../../store/slices';
import './BillingHeader.scss';

const CREDIT_CURRENCY_LOGO = AppConfig.creditCurrencyIcon || CreditCurrencyLogo;

const BillingHeader = ({ title, description }) => {
	const dispatch = useDispatch();
	const location = useLocation();

	const isBillingHome = location.pathname === '/billing-currency';

	const testIcon = () => {
		return (
			<div
				className='RootModal-header-gradient'
				style={{
					padding: '16px 0 32px 0',
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<img src={CREDIT_CURRENCY_LOGO} alt='modal-logo' width={81} height={81} />
			</div>
		);
	};

	const openBillingDetail = () => {
		dispatch(
			appSlice.actions.addModal({
				headerContent: testIcon(),
				headerBackground:
					'linear-gradient(180deg, rgba(4, 85, 163, 0.9) 0%, rgba(255, 255, 255, 0) 100%),rgb(var(--bg-primary))',
				tag: 'BillingInfoModal',
				isOpen: true,
				buttonStyles: { color: 'white', background: '#8CB1D5' },
				height: '70%',
				outsideParams: { showByButton: isBillingHome },
			})
		);
	};

	return (
		<div className='BillingHeader FormBlock'>
			<img src={CREDIT_CURRENCY_LOGO} alt='billing-logo' className='BillingHeader__logo' />
			<div className='BillingHeader__header'>{title}</div>
			<div className='BillingHeader__subheader'>{description}</div>
			<div className='BillingHeader__detail' onClick={openBillingDetail}>
				{t('Read more')}
			</div>
		</div>
	);
};

export default BillingHeader;
